<template>
	<ion-router-outlet />
</template>

<script setup lang="ts">
import { IonRouterOutlet } from "@ionic/vue"
</script>
